import m from '@bitstillery/mithril'
import {Spinner} from '@bitstillery/common/components/portal'
import {MithrilComponent} from '@bitstillery/mithril'
import {$t, api, notifier} from '@bitstillery/common/app'
import {route_param_text, route_path_param} from '@bitstillery/common/lib/utils'

import {$m} from '@/app'

export class AuthInvite extends MithrilComponent {
    override async oncreate() {
        const redirect_to = route_param_text(m.route.param('redirect'))

        const data = {invite_code: route_path_param('code')}
        const {success, result} = await api.post('portal/invite-login', data, true)
        if (!success) {
            notifier.notify($t('notifications.invite_failure'), 'danger', 7000)
            await m.route.set(redirect_to || '/')
            return
        }
        await $m.identity.new_token(result.token)
        await m.route.set(redirect_to || '/')
    }

    view() {
        return <Spinner />
    }
}
